(function () {
  var dismissButtonSelector =
    '#shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline';
  var exitClass = 'mystic-privacy-banner--exiting';
  var readyClass = 'mystic-privacy-banner--ready';
  var allowNativeClickAttribute = 'data-mystic-privacy-click-ready';
  var enhancedAttribute = 'data-mystic-privacy-enhanced';

  function addClasses(element, classNames) {
    classNames.forEach(function (className) {
      element.classList.add(className);
    });
  }

  function enhancePrivacyBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    var acceptButton;
    var declineButton;
    var manageButton;

    if (!banner || banner.hasAttribute(enhancedAttribute)) {
      return;
    }

    acceptButton = document.getElementById('shopify-pc__banner__btn-accept');
    declineButton = document.getElementById('shopify-pc__banner__btn-decline');
    manageButton = document.getElementById('shopify-pc__banner__btn-manage-prefs');

    if (acceptButton) {
      addClasses(acceptButton, ['btn', 'btn--lg', 'btn--primary']);
    }

    if (declineButton) {
      addClasses(declineButton, ['btn', 'btn--lg', 'btn--secondary']);
    }

    if (manageButton) {
      manageButton.textContent = 'Manage Preferences';
      addClasses(manageButton, ['link', 'unstyled-button', 'mystic-privacy-link']);
    }

    banner.setAttribute(enhancedAttribute, 'true');
    banner.classList.remove(exitClass);
    banner.classList.remove(readyClass);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        banner.classList.add(readyClass);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePrivacyBanner);
  } else {
    enhancePrivacyBanner();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(enhancePrivacyBanner).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target && event.target.closest(dismissButtonSelector);
      var banner;

      if (!button || button.hasAttribute(allowNativeClickAttribute)) {
        return;
      }

      banner = document.getElementById('shopify-pc__banner');

      if (!banner) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      banner.classList.add(exitClass);

      window.setTimeout(function () {
        button.setAttribute(allowNativeClickAttribute, 'true');
        button.click();
        button.removeAttribute(allowNativeClickAttribute);
      }, 620);
    },
    true
  );
})();
